import React from "react";
// TODO: ContentFormatter overuse
import {
  ContentFormatter,
  Type,
  Flex,
} from "discover.medical.react-component-library";
import { useStore } from "../../store";
import showdown from "showdown";
import { Announcement } from "./_.styled";

export const Announcements = ({ className }) => {
  const { announcements } = useStore().home;

  // no announcements, don't render anything
  if (!announcements || announcements.length === 0 || announcements.error) {
    return null;
  }

  return (
    <section data-testid="announcements-section" className={className}>
      <>
        <Type element="h2" fontFamily="secondary" marginBottom="sm">
          Announcements
        </Type>
        <Flex container wrap justify={{ content: "space-between" }}>
          {announcements.map(({ title, announcementId, description }) => (
            <Announcement key={announcementId} count={announcements.length}>
              <Type element="h3" styledAs="h4" fontFamily="secondary">
                {title}
              </Type>

              <ContentFormatter
                children={new showdown.Converter({
                  openLinksInNewWindow: true,
                }).makeHtml(description)}
              />
            </Announcement>
          ))}
        </Flex>
      </>
    </section>
  );
};

export default Announcements;
